import * as actionTypes from "../../actions/actionTypes";
import { updateObject } from "../../utility";

const initialState = {
  allProjects: null,
  projectsLoading: null,
  milestones: null,
  count: null,
  totalOfDone: null,
  pageS: 4,
  percentage: 0,
  loading: null,
  error: null,
};

// fetch all projects for milestone
const fetchClientProjectStart = (state, action) => {
  return updateObject(state, { error: null, projectsLoading: true });
};

const fetchClientProjectSuccess = (state, action) => {
  return updateObject(state, {
    allProjects: action.projects,
    error: null,
    projectsLoading: false,
  });
};

const fetchClientProjectFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    projectsLoading: false,
  });
};

// Milestone Precent
const MilestonePrecent = (state, action) => {
  return updateObject(state, {
    percentage: action.calc,
  });
};

// fetch milestone
const fetchProjectMilestonesStart = (state, action) => {
  return updateObject(state, { error: null, loading: true });
};

const fetchProjectMilestonesSuccess = (state, action) => {
  return updateObject(state, {
    milestones: action.milestones,
    count: action.count,
    totalOfDone: action.totalOfDone,
    percentage: action.percentage ? action.percentage : 0,
    error: null,
    loading: false,
  });
};

const fetchProjectMilestonesFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const clearMsgProjectMilestone = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    msg: null,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_PROJECTS_FOR_MILESTONE_START:
      return fetchClientProjectStart(state, action);
    case actionTypes.FETCH_USER_PROJECTS_FOR_MILESTONE_SUCCESS:
      return fetchClientProjectSuccess(state, action);
    case actionTypes.FETCH_USER_PROJECTS_FOR_MILESTONE_FAIL:
      return fetchClientProjectFail(state, action);

    case actionTypes.FETCH_USER_MILESTONES_START:
      return fetchProjectMilestonesStart(state, action);
    case actionTypes.FETCH_USER_MILESTONES_SUCCESS:
      return fetchProjectMilestonesSuccess(state, action);
    case actionTypes.FETCH_USER_MILESTONES_FAIL:
      return fetchProjectMilestonesFail(state, action);

    case actionTypes.USER_MILESTONE_PERCENT:
      return MilestonePrecent(state, action);

    case actionTypes.CLEAR_USER_MSG_MILESTONE:
      return clearMsgProjectMilestone(state, action);

    default:
      return state;
  }
};

export default reducer;
